import { compactUsdFormatter, usdFormatter } from '@/utils/format.js'

export const AFFILIATE_TIERS = [
  {
    name: 'Starter Tier',
    share: '20%',
    target: 0,
  },
  {
    name: 'Growth Tier',
    share: '35%',
    target: 5000,
  },
  {
    name: 'Elite Tier',
    share: '50%',
    target: 20000,
  },
].map((x, i) => {
  x.level = i + 1
  x.targetFormatted = usdFormatter.format(x.target)
  x.targetFormattedCompact = compactUsdFormatter.format(x.target)

  return x
})
